import { gql } from "@apollo/client";

export const GET_HISTORIAL_RECLAMO = gql`
query GetHistorialReclamo($idGestionReclamo: Int!){
    historialReclamoByIdGestionReclamo(idGestionReclamo: $idGestionReclamo){
        idHistorialReclamo
        idGestionReclamo
        fechaRealizacion
        descripcion
        idUsuario
        idEstadoReclamoNavigation{
            idEstadoReclamo
            descripcion
        }
        idEtapaReclamoNavigation{
            idEtapaReclamo
            descripcion
        }
        idUsuarioNavigation{
            nombre
            apellido
        }
    }
}`;

export const adaptEtapa = (etapa) => {
  return {
    id: etapa?.idHistorialReclamo,
    usuario: !!etapa?.idUsuarioNavigation ?
    etapa?.idUsuarioNavigation?.nombre + ' ' + etapa?.idUsuarioNavigation?.apellido :
    ' - ',
    etapa: etapa?.idEtapaReclamoNavigation?.descripcion,
    idEtapa: etapa?.idEtapaReclamoNavigation?.idEtapaReclamo,
    estado: etapa?.idEstadoReclamoNavigation?.descripcion,
    idEstado: etapa?.idEstadoReclamoNavigation?.idEstadoReclamo,
    fechaRealizacion: etapa?.fechaRealizacion,
    descripcion: etapa?.descripcion
  };
};

export const adaptHistorialArray = (
etapas) =>
{
  return structuredClone(etapas)?.
  map((etapa) => adaptEtapa(etapa));
};